import * as React from 'react';

import SurveySection from 'bundles/expression-of-interest/components/eoi-v1/modal-content/SurveySection';
import TerminalSection from 'bundles/expression-of-interest/components/eoi-v1/modal-content/TerminalSection';
import { SectionTypes } from 'bundles/university-program-qualification/utils/constants';
import LoadingIcon from 'bundles/xddp/components/shared/LoadingIcon';
import type { EoiSectionPropTypes } from 'bundles/xddp/types';

import 'css!bundles/xddp/components/__styles__/eoi/EoiBody';

type Props = {
  slug: string;
  section: EoiSectionPropTypes;
  isSubmitting: boolean;
  eoiConfirmationText?: string;
};

function EoiBody({ slug, section, isSubmitting, eoiConfirmationText }: Props) {
  const getComponentToDisplay = () => {
    if (isSubmitting) {
      return (
        <div className="loader-signal-body">
          <LoadingIcon size="large" color="interactive" />
        </div>
      );
    } else if (section.sectionType === SectionTypes.QUESTION) {
      return <SurveySection slug={slug} sectionData={section} />;
    } else if (section.sectionType === SectionTypes.TERMINAL) {
      return <TerminalSection sectionData={section} eoiConfirmationText={eoiConfirmationText} />;
    }
    return null;
  };

  return <div className="rc-EoiBody">{getComponentToDisplay()}</div>;
}

export default EoiBody;
